__turbopack_context__.v({
  "fundraisercontainer": "XPACfa_fundraisercontainer",
  "fundraiserdata": "XPACfa_fundraiserdata",
  "fundraiserdescription": "XPACfa_fundraiserdescription",
  "mobiletitle": "XPACfa_mobiletitle",
});
